import React, { Component, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import '../index.css';
import { resetPassword } from '../modules/NetworkFunction';

function PwReset({ history }) {
  const [isErr, setIsErr] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userId, setUserId] = useState(-1);
  const onChange = (e) => {
    const { value, name } = e.target;

    if (name === 'password') {
      setPassword(value);
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
    }
  };

  const handlePwChangeBtn = () => {
    // history.push({
    //   pathname: '/Login',
    // });
    const url = window.location.href;
    // JWT 토큰 추출
    const token = url.split('/').pop();

    // JWT 페이로드 디코드
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    setUserId(payload.userId);
    console.log(payload);

    const passwordChangeParam = {
      token: token,
      userPW: password,
    };
    console.log(passwordChangeParam);
    resetPassword(
      passwordChangeParam,
      (e) => {
        alert('비밀번호가 성공적으로 변경되었습니다.');
        history.push({
          pathname: '/login',
        });
      },
      () => {},
      () => {}
    );
  };

  useEffect(() => {
    if (password === '' && confirmPassword === '') {
      setIsErr(true);
      setIsEmpty(true);
    } else if (
      password === '' ||
      confirmPassword === '' ||
      password !== confirmPassword ||
      password.length < 8
    ) {
      setIsErr(true);
      setIsEmpty(false);
    } else {
      setIsErr(false);
      setIsEmpty(false);
    }
  }, [password, confirmPassword]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#DDDDDD',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 100,
        paddingBottom: 100,
        height: '100vh',
      }}
    >
      <div
        style={{
          width: 510,
          height: 515,
          borderRadius: 23,
          backgroundColor: '#F9F9F9',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          alt="wizmon-logo"
          src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-wizmon-logo-login.png"
          style={{ width: 280, height: 60, marginTop: 42 }}
        />
        <div
          style={{
            width: 337,
            height: 27,
            marginTop: 62,
            fontWeight: 600,
            fontSize: 20,
            color: '#292A2E',
          }}
        >
          비밀번호 찾기
        </div>
        <div
          style={{
            width: 337,
            height: 22,
            marginTop: 10,
            fontWeight: 'normal',
            fontSize: 16,
            color: '#848484',
          }}
        >
          새로운 비밀번호를 입력해 주세요.
        </div>
        <p
          style={{
            width: 337,
            height: 22,
            fontSize: 16,
            fontWeight: 400,
            color: '#FF7A00',
            marginTop: 12,
          }}
        >
          {!isEmpty && isErr ? '비밀번호를 다시 확인해주세요.' : '  '}
        </p>
        <input
          placeholder="새로운 비밀번호 (8자리 이상)"
          value={password}
          name="password"
          onChange={onChange}
          type="password"
          style={{
            width: 337,
            height: 50,
            borderRadius: 25,
            paddingLeft: 20,
            paddingRight: 20,
            marginBottom: 15,
            marginTop: 8,
            border:
              !isEmpty && isErr ? '1px solid #FF7A00' : '0.8px solid #CCCCCC',
          }}
          onKeyPress={handleKeyPress}
        />

        <input
          placeholder="새로운 비밀번호 확인"
          value={confirmPassword}
          name="confirmPassword"
          onChange={onChange}
          type="password"
          style={{
            width: 337,
            height: 50,
            borderRadius: 25,
            paddingLeft: 20,
            paddingRight: 20,
            marginBottom: 15,
            marginTop: 8,
            border:
              !isEmpty && isErr ? '1px solid #FF7A00' : '0.8px solid #CCCCCC',
          }}
          onKeyPress={handleKeyPress}
        />

        <button
          style={{
            width: 337,
            height: 54,
            borderRadius: 25,
            backgroundColor: '#B5B5B5',
            color: 'white',
            borderWidth: 0,
            marginTop: 25,
            marginBottom: 15,
            fontSize: 22,
            fontWeight: 600,
            cursor: 'pointer',
          }}
          onClick={handlePwChangeBtn}
          disabled={isErr}
        >
          비밀번호 변경
        </button>
      </div>
    </div>
  );
}

export default withRouter(PwReset);
